/**
 * 预置书签数据
 * 涵盖程序员常用网站和通用网站
 */

export const defaultBookmarks = [
  // ========== 开发工具 ==========
  {
    id: 'github',
    name: 'GitHub',
    url: 'https://github.com',
    icon: 'https://github.githubassets.com/favicons/favicon.svg',
    description: '全球最大的代码托管平台',
    categoryId: 'code-hosting',
    tags: ['git', '代码', '开源'],
    isDefault: true
  },
  {
    id: 'gitlab',
    name: 'GitLab',
    url: 'https://gitlab.com',
    icon: 'https://gitlab.com/favicon.ico',
    description: 'DevOps平台，支持私有部署',
    categoryId: 'code-hosting',
    tags: ['git', 'devops'],
    isDefault: true
  },
  {
    id: 'gitee',
    name: 'Gitee',
    url: 'https://gitee.com',
    icon: 'https://gitee.com/favicon.ico',
    description: '国内代码托管平台',
    categoryId: 'code-hosting',
    tags: ['git', '国内'],
    isDefault: true
  },
  {
    id: 'vscode-web',
    name: 'VS Code Web',
    url: 'https://vscode.dev',
    icon: 'https://code.visualstudio.com/favicon.ico',
    description: '在线版VS Code编辑器',
    categoryId: 'dev-tools',
    tags: ['编辑器', '在线'],
    isDefault: true
  },
  {
    id: 'codepen',
    name: 'CodePen',
    url: 'https://codepen.io',
    icon: 'https://codepen.io/favicon.ico',
    description: '前端代码演示平台',
    categoryId: 'dev-tools',
    tags: ['前端', '演示'],
    isDefault: true
  },
  {
    id: 'codesandbox',
    name: 'CodeSandbox',
    url: 'https://codesandbox.io',
    icon: 'https://codesandbox.io/favicon.ico',
    description: '在线IDE，支持多种框架',
    categoryId: 'dev-tools',
    tags: ['IDE', '在线'],
    isDefault: true
  },
  {
    id: 'stackblitz',
    name: 'StackBlitz',
    url: 'https://stackblitz.com',
    icon: 'https://stackblitz.com/favicon.ico',
    description: '基于浏览器的全栈开发环境',
    categoryId: 'dev-tools',
    tags: ['IDE', '全栈'],
    isDefault: true
  },

  // ========== 技术文档 ==========
  {
    id: 'mdn',
    name: 'MDN Web Docs',
    url: 'https://developer.mozilla.org',
    icon: 'https://developer.mozilla.org/favicon-48x48.png',
    description: 'Mozilla开发者网络，Web技术权威文档',
    categoryId: 'dev-docs',
    tags: ['前端', 'Web', '文档'],
    isDefault: true
  },
  {
    id: 'devdocs',
    name: 'DevDocs',
    url: 'https://devdocs.io',
    icon: 'https://devdocs.io/favicon.ico',
    description: '聚合多种技术文档的查询工具',
    categoryId: 'dev-docs',
    tags: ['文档', '聚合'],
    isDefault: true
  },
  {
    id: 'vuejs',
    name: 'Vue.js',
    url: 'https://vuejs.org',
    icon: 'https://vuejs.org/logo.svg',
    description: 'Vue框架官方文档',
    categoryId: 'dev-docs',
    tags: ['前端', 'Vue', '框架'],
    isDefault: true
  },
  {
    id: 'react',
    name: 'React',
    url: 'https://react.dev',
    icon: 'https://react.dev/favicon.ico',
    description: 'React框架官方文档',
    categoryId: 'dev-docs',
    tags: ['前端', 'React', '框架'],
    isDefault: true
  },
  {
    id: 'nodejs',
    name: 'Node.js',
    url: 'https://nodejs.org',
    icon: 'https://nodejs.org/favicon.ico',
    description: 'Node.js官方网站',
    categoryId: 'dev-docs',
    tags: ['后端', 'JavaScript'],
    isDefault: true
  },
  {
    id: 'python',
    name: 'Python',
    url: 'https://python.org',
    icon: 'https://www.python.org/favicon.ico',
    description: 'Python官方网站',
    categoryId: 'dev-docs',
    tags: ['后端', 'Python'],
    isDefault: true
  },
  {
    id: 'flutter',
    name: 'Flutter',
    url: 'https://flutter.dev',
    icon: 'https://flutter.dev/favicon.ico',
    description: 'Flutter跨平台框架官方文档',
    categoryId: 'dev-docs',
    tags: ['移动端', 'Flutter', '跨平台'],
    isDefault: true
  },

  // ========== AI工具 ==========
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    url: 'https://chat.openai.com',
    icon: 'https://chat.openai.com/favicon.ico',
    description: 'OpenAI的AI对话助手',
    categoryId: 'ai-tools',
    tags: ['AI', '对话', 'OpenAI'],
    isDefault: true
  },
  {
    id: 'claude',
    name: 'Claude',
    url: 'https://claude.ai',
    icon: 'https://claude.ai/favicon.ico',
    description: 'Anthropic的AI助手',
    categoryId: 'ai-tools',
    tags: ['AI', '对话'],
    isDefault: true
  },
  {
    id: 'gemini',
    name: 'Gemini',
    url: 'https://gemini.google.com',
    icon: 'https://www.gstatic.com/lamda/images/gemini_favicon_f069958c85030f63fd3b.ico',
    description: 'Google AI助手',
    categoryId: 'ai-tools',
    tags: ['AI', 'Google'],
    isDefault: true
  },
  {
    id: 'perplexity',
    name: 'Perplexity',
    url: 'https://perplexity.ai',
    icon: 'https://perplexity.ai/favicon.ico',
    description: 'AI搜索引擎',
    categoryId: 'ai-tools',
    tags: ['AI', '搜索'],
    isDefault: true
  },
  {
    id: 'copilot',
    name: 'GitHub Copilot',
    url: 'https://github.com/features/copilot',
    icon: 'https://github.githubassets.com/favicons/favicon.svg',
    description: 'AI代码助手',
    categoryId: 'ai-tools',
    tags: ['AI', '代码'],
    isDefault: true
  },
  {
    id: 'midjourney',
    name: 'Midjourney',
    url: 'https://midjourney.com',
    icon: 'https://midjourney.com/favicon.ico',
    description: 'AI图像生成',
    categoryId: 'ai-tools',
    tags: ['AI', '图像'],
    isDefault: true
  },
  {
    id: 'huggingface',
    name: 'Hugging Face',
    url: 'https://huggingface.co',
    icon: 'https://huggingface.co/favicon.ico',
    description: 'AI模型社区和平台',
    categoryId: 'ai-tools',
    tags: ['AI', '模型', '开源'],
    isDefault: true
  },

  // ========== 云服务 ==========
  {
    id: 'aws',
    name: 'AWS',
    url: 'https://aws.amazon.com',
    icon: 'https://aws.amazon.com/favicon.ico',
    description: 'Amazon云服务',
    categoryId: 'cloud-services',
    tags: ['云', 'Amazon'],
    isDefault: true
  },
  {
    id: 'aliyun',
    name: '阿里云',
    url: 'https://aliyun.com',
    icon: 'https://img.alicdn.com/tfs/TB1_ZXuNcfpK1RjSZFOXXa6nFXa-32-32.ico',
    description: '阿里巴巴云计算服务',
    categoryId: 'cloud-services',
    tags: ['云', '国内'],
    isDefault: true
  },
  {
    id: 'tencent-cloud',
    name: '腾讯云',
    url: 'https://cloud.tencent.com',
    icon: 'https://cloudcache.tencent-cloud.com/favicon.ico',
    description: '腾讯云计算服务',
    categoryId: 'cloud-services',
    tags: ['云', '国内'],
    isDefault: true
  },
  {
    id: 'vercel',
    name: 'Vercel',
    url: 'https://vercel.com',
    icon: 'https://vercel.com/favicon.ico',
    description: '前端部署平台',
    categoryId: 'cloud-services',
    tags: ['部署', '前端'],
    isDefault: true
  },
  {
    id: 'netlify',
    name: 'Netlify',
    url: 'https://netlify.com',
    icon: 'https://netlify.com/favicon.ico',
    description: '静态网站部署平台',
    categoryId: 'cloud-services',
    tags: ['部署', '静态'],
    isDefault: true
  },

  // ========== 技术社区 ==========
  {
    id: 'stackoverflow',
    name: 'Stack Overflow',
    url: 'https://stackoverflow.com',
    icon: 'https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico',
    description: '全球最大的程序员问答社区',
    categoryId: 'dev-community',
    tags: ['问答', '社区'],
    isDefault: true
  },
  {
    id: 'juejin',
    name: '稀土掘金',
    url: 'https://juejin.cn',
    icon: 'https://lf3-cdn-tos.bytescm.com/obj/static/xitu_juejin_web/static/favicons/favicon-32x32.png',
    description: '中文开发者社区',
    categoryId: 'dev-community',
    tags: ['社区', '国内'],
    isDefault: true
  },
  {
    id: 'csdn',
    name: 'CSDN',
    url: 'https://csdn.net',
    icon: 'https://g.csdnimg.cn/static/logo/favicon32.ico',
    description: '中国开发者社区',
    categoryId: 'dev-community',
    tags: ['社区', '国内'],
    isDefault: true
  },
  {
    id: 'v2ex',
    name: 'V2EX',
    url: 'https://v2ex.com',
    icon: 'https://v2ex.com/favicon.ico',
    description: '创意工作者社区',
    categoryId: 'dev-community',
    tags: ['社区', '讨论'],
    isDefault: true
  },
  {
    id: 'segmentfault',
    name: 'SegmentFault',
    url: 'https://segmentfault.com',
    icon: 'https://segmentfault.com/favicon.ico',
    description: '技术问答社区',
    categoryId: 'dev-community',
    tags: ['问答', '国内'],
    isDefault: true
  },

  // ========== 设计工具 ==========
  {
    id: 'figma',
    name: 'Figma',
    url: 'https://figma.com',
    icon: 'https://static.figma.com/app/icon/1/favicon.png',
    description: '协作设计工具',
    categoryId: 'design-tools',
    tags: ['设计', 'UI'],
    isDefault: true
  },
  {
    id: 'canva',
    name: 'Canva',
    url: 'https://canva.com',
    icon: 'https://canva.com/favicon.ico',
    description: '在线设计平台',
    categoryId: 'design-tools',
    tags: ['设计', '图片'],
    isDefault: true
  },
  {
    id: 'adobe-cc',
    name: 'Adobe Creative Cloud',
    url: 'https://adobe.com/creativecloud.html',
    icon: 'https://www.adobe.com/favicon.ico',
    description: 'Adobe创意套件',
    categoryId: 'design-tools',
    tags: ['设计', 'Adobe'],
    isDefault: true
  },

  // ========== 设计资源 ==========
  {
    id: 'iconfont',
    name: 'iconfont',
    url: 'https://iconfont.cn',
    icon: 'https://img.alicdn.com/imgextra/i4/O1CN01Z5paLz1O0zuCC7osS_!!6000000001644-55-tps-83-82.svg',
    description: '阿里图标库',
    categoryId: 'design-resources',
    tags: ['图标', '免费'],
    isDefault: true
  },
  {
    id: 'unsplash',
    name: 'Unsplash',
    url: 'https://unsplash.com',
    icon: 'https://unsplash.com/favicon.ico',
    description: '免费高质量图片',
    categoryId: 'design-resources',
    tags: ['图片', '免费'],
    isDefault: true
  },
  {
    id: 'dribbble',
    name: 'Dribbble',
    url: 'https://dribbble.com',
    icon: 'https://dribbble.com/favicon.ico',
    description: '设计师作品分享平台',
    categoryId: 'design-resources',
    tags: ['设计', '灵感'],
    isDefault: true
  },
  {
    id: 'colorhunt',
    name: 'Color Hunt',
    url: 'https://colorhunt.co',
    icon: 'https://colorhunt.co/favicon.ico',
    description: '配色方案收集',
    categoryId: 'design-resources',
    tags: ['配色', '设计'],
    isDefault: true
  },

  // ========== 效率工具 ==========
  {
    id: 'notion',
    name: 'Notion',
    url: 'https://notion.so',
    icon: 'https://www.notion.so/images/favicon.ico',
    description: '全能笔记和知识管理',
    categoryId: 'productivity',
    tags: ['笔记', '协作'],
    isDefault: true
  },
  {
    id: 'obsidian',
    name: 'Obsidian',
    url: 'https://obsidian.md',
    icon: 'https://obsidian.md/favicon.ico',
    description: '本地优先的知识库',
    categoryId: 'productivity',
    tags: ['笔记', '本地'],
    isDefault: true
  },
  {
    id: 'trello',
    name: 'Trello',
    url: 'https://trello.com',
    icon: 'https://trello.com/favicon.ico',
    description: '看板式项目管理',
    categoryId: 'productivity',
    tags: ['项目管理', '看板'],
    isDefault: true
  },
  {
    id: 'todoist',
    name: 'Todoist',
    url: 'https://todoist.com',
    icon: 'https://todoist.com/favicon.ico',
    description: '任务管理工具',
    categoryId: 'productivity',
    tags: ['任务', 'GTD'],
    isDefault: true
  },

  // ========== 在线工具 ==========
  {
    id: 'regex101',
    name: 'Regex101',
    url: 'https://regex101.com',
    icon: 'https://regex101.com/favicon.ico',
    description: '正则表达式测试工具',
    categoryId: 'online-tools',
    tags: ['正则', '测试'],
    isDefault: true
  },
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    url: 'https://jsonformatter.org',
    icon: 'https://jsonformatter.org/favicon.ico',
    description: 'JSON格式化和验证',
    categoryId: 'online-tools',
    tags: ['JSON', '格式化'],
    isDefault: true
  },
  {
    id: 'carbon',
    name: 'Carbon',
    url: 'https://carbon.now.sh',
    icon: 'https://carbon.now.sh/favicon.ico',
    description: '代码截图美化工具',
    categoryId: 'online-tools',
    tags: ['代码', '截图'],
    isDefault: true
  },
  {
    id: 'tinypng',
    name: 'TinyPNG',
    url: 'https://tinypng.com',
    icon: 'https://tinypng.com/favicon.ico',
    description: '图片压缩工具',
    categoryId: 'online-tools',
    tags: ['图片', '压缩'],
    isDefault: true
  },
  {
    id: 'excalidraw',
    name: 'Excalidraw',
    url: 'https://excalidraw.com',
    icon: 'https://excalidraw.com/favicon.ico',
    description: '手绘风格白板工具',
    categoryId: 'online-tools',
    tags: ['白板', '绘图'],
    isDefault: true
  },
  {
    id: 'draw-io',
    name: 'draw.io',
    url: 'https://draw.io',
    icon: 'https://draw.io/favicon.ico',
    description: '流程图绘制工具',
    categoryId: 'online-tools',
    tags: ['流程图', '图表'],
    isDefault: true
  },

  // ========== 学习平台 ==========
  {
    id: 'coursera',
    name: 'Coursera',
    url: 'https://coursera.org',
    icon: 'https://coursera.org/favicon.ico',
    description: '全球知名在线学习平台',
    categoryId: 'learning',
    tags: ['课程', '在线'],
    isDefault: true
  },
  {
    id: 'udemy',
    name: 'Udemy',
    url: 'https://udemy.com',
    icon: 'https://udemy.com/favicon.ico',
    description: '技能学习平台',
    categoryId: 'learning',
    tags: ['课程', '技能'],
    isDefault: true
  },
  {
    id: 'leetcode',
    name: 'LeetCode',
    url: 'https://leetcode.com',
    icon: 'https://leetcode.com/favicon.ico',
    description: '算法刷题平台',
    categoryId: 'learning',
    tags: ['算法', '面试'],
    isDefault: true
  },
  {
    id: 'freecodecamp',
    name: 'freeCodeCamp',
    url: 'https://freecodecamp.org',
    icon: 'https://freecodecamp.org/favicon.ico',
    description: '免费编程学习平台',
    categoryId: 'learning',
    tags: ['编程', '免费'],
    isDefault: true
  },

  // ========== 科技资讯 ==========
  {
    id: 'hackernews',
    name: 'Hacker News',
    url: 'https://news.ycombinator.com',
    icon: 'https://news.ycombinator.com/favicon.ico',
    description: '科技创业新闻',
    categoryId: 'tech-news',
    tags: ['新闻', '创业'],
    isDefault: true
  },
  {
    id: '36kr',
    name: '36氪',
    url: 'https://36kr.com',
    icon: 'https://36kr.com/favicon.ico',
    description: '科技创投媒体',
    categoryId: 'tech-news',
    tags: ['新闻', '国内'],
    isDefault: true
  },
  {
    id: 'infoq',
    name: 'InfoQ',
    url: 'https://infoq.cn',
    icon: 'https://infoq.cn/favicon.ico',
    description: '软件开发资讯',
    categoryId: 'tech-news',
    tags: ['技术', '资讯'],
    isDefault: true
  },

  // ========== 社交媒体 ==========
  {
    id: 'twitter',
    name: 'Twitter/X',
    url: 'https://twitter.com',
    icon: 'https://twitter.com/favicon.ico',
    description: '全球社交平台',
    categoryId: 'social-media',
    tags: ['社交', '国际'],
    isDefault: true
  },
  {
    id: 'zhihu',
    name: '知乎',
    url: 'https://zhihu.com',
    icon: 'https://zhihu.com/favicon.ico',
    description: '知识问答社区',
    categoryId: 'social-media',
    tags: ['问答', '国内'],
    isDefault: true
  },
  {
    id: 'weibo',
    name: '微博',
    url: 'https://weibo.com',
    icon: 'https://weibo.com/favicon.ico',
    description: '中国社交媒体平台',
    categoryId: 'social-media',
    tags: ['社交', '国内'],
    isDefault: true
  },

  // ========== 影音娱乐 ==========
  {
    id: 'youtube',
    name: 'YouTube',
    url: 'https://youtube.com',
    icon: 'https://youtube.com/favicon.ico',
    description: '全球视频平台',
    categoryId: 'entertainment',
    tags: ['视频', '国际'],
    isDefault: true
  },
  {
    id: 'bilibili',
    name: '哔哩哔哩',
    url: 'https://bilibili.com',
    icon: 'https://bilibili.com/favicon.ico',
    description: '中国视频平台',
    categoryId: 'entertainment',
    tags: ['视频', '国内'],
    isDefault: true
  },
  {
    id: 'spotify',
    name: 'Spotify',
    url: 'https://spotify.com',
    icon: 'https://spotify.com/favicon.ico',
    description: '音乐流媒体',
    categoryId: 'entertainment',
    tags: ['音乐', '国际'],
    isDefault: true
  },
  {
    id: 'netease-music',
    name: '网易云音乐',
    url: 'https://music.163.com',
    icon: 'https://music.163.com/favicon.ico',
    description: '国内音乐平台',
    categoryId: 'entertainment',
    tags: ['音乐', '国内'],
    isDefault: true
  },

  // ========== 网上购物 ==========
  {
    id: 'taobao',
    name: '淘宝',
    url: 'https://taobao.com',
    icon: 'https://taobao.com/favicon.ico',
    description: '阿里巴巴电商平台',
    categoryId: 'shopping',
    tags: ['购物', '国内'],
    isDefault: true
  },
  {
    id: 'jd',
    name: '京东',
    url: 'https://jd.com',
    icon: 'https://jd.com/favicon.ico',
    description: '京东电商平台',
    categoryId: 'shopping',
    tags: ['购物', '国内'],
    isDefault: true
  },
  {
    id: 'amazon',
    name: 'Amazon',
    url: 'https://amazon.com',
    icon: 'https://amazon.com/favicon.ico',
    description: '全球电商平台',
    categoryId: 'shopping',
    tags: ['购物', '国际'],
    isDefault: true
  }
]

export default defaultBookmarks
